import React, { useCallback } from "react";

import { Modal, SettingsPasswordForm } from "../../components";
import "../../styles/components/modals/_change-password.scss";
import { useDispatch, useSelector } from "react-redux";
import { setModalPasswordResetClosed } from "../../actions/modals";

function PasswordResetModal() {
  const { passwordResetOpen } = useSelector((state) => state.modals);
  const dispatch = useDispatch();

  const handlePasswordResetClosed = useCallback(() => {
    dispatch(setModalPasswordResetClosed());
  }, [dispatch]);

  return (
    <Modal isOpen={passwordResetOpen} modalName="change-password" onClose={handlePasswordResetClosed}>
      <SettingsPasswordForm onClose={handlePasswordResetClosed} />
    </Modal>
  );
}

export default PasswordResetModal;
